<template>

  <div class="wrapper wrapper-content animated fadeInRight">
  
    <div class="ibox-content m-b-sm border-bottom">
    <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
      <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
        <div class="tab-content">
          <div>
            <div class="listTab">
              <div>{{ $t("message.Centres Title") }}</div>
                <draggable
                  class="sortable-list connectList0 agile-list"
                  v-model="homePageObj.topBannerVoList"
                  style="max-height: 900px; overflow: auto; margin-bottom: 15px;"
                  group="topBanner"
                  @start="drag = true"
                  @end="drag = false"
                >
                  <div v-for="(topBanner, index) in homePageObj.topBannerVoList" class="dragObj" :key="index">
                    <div style="padding: 5px">
                      <span style="display: inline-block">
                        {{ $t("message.TopBanner name:") }}
                        {{ topBanner["topBannerName" + $i18n.locale] }}
                      </span>
                    </div>
                    <a
                      class="pull-right btn btn-xs btn-white"
                      style="position: absolute; top: 10px; right: 10px;"
                      @click="deleteTopBanner(index)"
                    >
                      {{ $t("message.Delete") }}
                    </a>
                  </div>
                </draggable>
            </div>
            </div>
          </div>
        </form>
      </div>
                            
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">{{ $t("message.Import Content") }}</label>
          <div class="col-sm-3">
            <div>
              <input
                class=""
                type="file"
                ref="file"
                accept="xls/*"
                @change="handleFileUpload()"
              />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="btn btn-primary" @click="downloadTemplate()">
              {{ $t("message.download") }}
            </div>
          </div>
        </div>
        <div class="form-group" v-if="lastTemplate">
          <label class="col-sm-2 control-label">
            {{$t("message.lastFile") }}
          </label>
          <div class="col-sm-3">
            <div style="margin-top: 7px">
              <a :href="lastTemplate" target="_blank">{{fileName}}</a>
            </div>
          </div>
        </div>
        <div class="form-group" v-if="uploadTime">
          <label class="col-sm-2 control-label">
            {{$t("message.last update time") }}
          </label>
          <div class="col-sm-3">
            <div style="margin-top: 7px">
              {{ uploadTime }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">{{ $t("message.Centres Banner") }}</label>
          <div class="col-sm-4">
            <div class="imageUpload">
              <el-upload
                class="upload-demo"
                ref="originalUpload"
                action="#"
                :on-remove="(file, fileList) => { handleRemove('originalFileList', file, fileList) }"
                :on-change="(file, fileList) => { handleUploadFileChange('originalFileList', file, fileList) }"
                :file-list="originalFileList"
                :auto-upload="false"
                multiple
                accept="image/jpg,image/jpeg,image/png"
              >
                <el-button slot="trigger" size="small" type="primary">{{ $t("message.Select file") }}</el-button>
                <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload('originalFileList', 'Original')">{{ $t("message.upload") }}</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";
import axios from "axios"
import draggable from "vuedraggable";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  data() {
    return {
      page: 1,
      template:"",
      lastTemplate:"",
      fileName: "",
      uploadTime: "",
      cropFileList: [],
      originalFileList: [],
      isSave: false,
      language: "en_US",
      topBannerList: [],
      homePageObj: {
        bannerList: [],
        articleList: [],
        floatingBannerVoList: [],
        departmentBannerVoList: [],
        topBannerVoList: [],
      },
      topBannerId: "",
    };
  },
  created: function() {
    this.init();
    this.getTopBannerList();
    this.exportEvent();
  },
  components: {
    draggable,
  },
  methods: {
    async init() {
      let obj = this.getAuthObj;
      let data = await this.$store.dispatch("getHomePageDraft",this.setFormData(obj));
      for (var i = 0; i < data.data.result.topBannerVoList.length; i++) {
        for (var j = 0; j < data.data.result.topBannerVoList[i].langMap.length; j++) {
          if (data.data.result.topBannerVoList[i].langMap[j].langCode == "en_US") {
            data.data.result.topBannerVoList[i]["topBannerName" + "en_US"] = data.data.result.topBannerVoList[i].langMap[j].topBannerName;
          }
          if (data.data.result.topBannerVoList[i].langMap[j].langCode == "zh_HK") {
            data.data.result.topBannerVoList[i]["topBannerName" + "zh_HK"] = data.data.result.topBannerVoList[i].langMap[j].topBannerName;
          }
          if (data.data.result.topBannerVoList[i].langMap[j].langCode == "zh_CN") {
            data.data.result.topBannerVoList[i]["topBannerName" + "zh_CN"] = data.data.result.topBannerVoList[i].langMap[j].topBannerName;
          }
        }
      }
      this.$set(this, "homePageObj", data.data.result);
    },
    async getTopBannerList() {
      let obj = this.getAuthObj;
      obj.startRow = 0;
      obj.maxRows = 10000;
      let data = await this.$store.dispatch("getTopBannerList", this.setFormData(obj));

      for(var i=0; i<data.data.resultList.length; i++) {
        for(var j=0; j<data.data.resultList[i].langMap.length; j++) {
          if( data.data.resultList[i].langMap[j].langCode=="en_US" ){
            data.data.resultList[i]['topBannerName'+'en_US'] = data.data.resultList[i].langMap[j].topBannerName;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['topBannerName'+'zh_HK'] = data.data.resultList[i].langMap[j].topBannerName;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['topBannerName'+'zh_CN'] = data.data.resultList[i].langMap[j].topBannerName;
          }
        }
      }
      this.$set(this, "topBannerList", data.data.resultList);
    },
    deleteTopBanner: function (index) {
      this.homePageObj.topBannerVoList.splice(index, 1);
    },
    addTopBanner: function () {
      for (var i = 0; i < this.topBannerList.length; i++) {
        if (this.topBannerList[i].id == this.topBannerId) {
          this.homePageObj.topBannerVoList.push(this.topBannerList[i]);
        }
      }
      this.topBannerId = "";
    },
    async handleFileUpload() {
      this.file = this.$refs.file.files[0];
      
      let formData = new FormData();

      /*
                Add the form data we need to submit
            */
      formData.append("file", this.file);
      formData.append('session', this.$store.state.userInfo.session);
      formData.append('userId', this.$store.state.userInfo.systemUserId);
      formData.append('lang', "en_US")
      /*
          Make the request to the POST /single-file URL
        */
      axios
        .post(this.domain+'/importOccupation', formData)
        .then(data => {
          if (data.data.errorCode === 0) {
            this.$toastr.s("Import success");
            this.exportEvent();
          }else{
            var that = this
            this.$store.commit("setwarning", {
                string: data.data.errorMessage,
                boolean: true,
                button: [{
                  name:this.$i18n.t("message.Cancel"),
                  callBack:function(){
                    that.$store.commit("setwarning", {
                      string: "",
                      boolean: false,
                    });
                  }
                }]
            })
          }
          this.$refs.file.value = "";
        })
        .catch((e) => {
          this.$toastr.w("Time out, you can check status later","Warning");
          this.$refs.file.value = "";
        });
    
    },
    async exportEvent() {
      var that = this;
      let obj = this.getAuthObj;
      let data = await this.$store.dispatch("exportOccupation", this.setFormData(obj));

      if(data.data.result){
        this.template = data.data.result.templatePath;
        this.lastTemplate = data.data.result.filePath;
        this.fileName = data.data.result.fileName;
        this.uploadTime = data.data.result.uploadTime;
      }
    },
    downloadTemplate(){
      window.open(this.template )
    },

    submitUpload(files, type) {
      let formData = new FormData();

      /* Add the form data we need to submit */
      for(let val of this[files]) {
        formData.append("files", val.raw);
      }
      formData.append('session', this.$store.state.userInfo.session);
      formData.append('userId', this.$store.state.userInfo.systemUserId);
      formData.append('lang', "en_US")
      formData.append('type', type)

      /* Make the request to the POST /single-file URL */
      axios.post(this.domain+'/uploadImageFiles', formData).then(data => {
        if (data.data.errorCode === 0) {
          this.$toastr.s(this.$t("message.Upload success"));
        }else{
          var that = this;
          this.$store.commit("setwarning", {
              string: data.data.errorMessage,
              boolean: true,
              button: [{
                name:this.$i18n.t("message.Cancel"),
                callBack:function(){
                  that.$store.commit("setwarning", {
                    string: "",
                    boolean: false,
                  });
                }
              }]
          })
        }
        this[files] = [];
      }).catch((e) => {
        this.$toastr.w("Time out, you can check status later","Warning");
        this[files] = [];
      });
    },
    handleRemove(type, file, fileList) {
      this[type] = fileList
    },
    handleUploadFileChange(type, file, fileList) {
      this[type] = fileList;
    },
    addTopBanner: function () {
      for (var i = 0; i < this.topBannerList.length; i++) {
        if (this.topBannerList[i].id == this.topBannerId) {
          this.homePageObj.topBannerVoList.push(this.topBannerList[i]);
        }
      }
      this.topBannerId = "";
    },
  },
  mounted() {
  },
};
</script>